import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import About from "./components/About";
import VisionMission from "./components/VisionMission";
import Academics from "./components/Academics";
import Management from "./components/Management";
import Footer from "./components/Footer";
import "./App.css";
import Contact from "./components/Contact";

function App() {
  return (
    <>
      <Navbar />
      <Hero />
      <About />
      <VisionMission />
      <Academics />
      <Management />
      <Footer />
      <Contact/>
    </>
  );
}

export default App;
